module.exports = __webpack_public_path__ + "fonts/Roboto-400-cyrillic32.f92ee38.woff2";